import { computedFrom } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { PortVesselsFiltersViewModel } from "../../tabs/mep-vessels/partials/mep-vessels-filters/mep-vessels-filters";
import { MepService } from "../../../../../../services/mep/mep.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import * as Enumerable from "linq";
import { I18N } from "aurelia-i18n";

@autoinject()
@transient()
export class UploadVesselPortActivitiesDialog {

    private readonly _supportedTypes = [
        {
            type: "csv",
            mime: "text/csv"
        }
    ];

    public filterViewModel: PortVesselsFiltersViewModel;
    public vesselPortActivitiesFiles: File[] = [];

    constructor(private mepService: MepService,
        private dialogClientService: DialogClientService,
        private i18N: I18N,
        private notificationClientService: NotificationClientService) {

    }

    @computedFrom("_supportedTypes")
    public get acceptTypes(): string {
        return this._supportedTypes.filter(x => x.mime && x.mime.trim() != "").map(x => x.mime).join(",");
    }

    public activate(model: { filterViewModel: PortVesselsFiltersViewModel }) {
        this.filterViewModel = model.filterViewModel;
    }

    close() {
        this.dialogClientService.hide();
    }

    submit() {
        return new Promise<void>((resolve, reject) => {
            if ( this.vesselPortActivitiesFiles && this.vesselPortActivitiesFiles.length > 1) {
                this.notificationClientService.show("Error", this.i18N.tr('upload-multiple-files-not-allow-text'), NotificationType.Error);
                reject();
                return;
            }
            if (this.checkCorrectFileTypes(this.vesselPortActivitiesFiles)) {
                this.mepService.uploadMepVesselPortActivities({
                    file: this.vesselPortActivitiesFiles[0],
                    unPortCode: this.filterViewModel.portUnlocode
                }).then(() => {
                    this.dialogClientService.hide(true);
                    this.notificationClientService.show(``, `File uploaded for processing`, NotificationType.Success);
                    resolve();
                }).catch(() => {
                    this.notificationClientService.show(``, `Faile to upload the file`, NotificationType.Error);
                    reject();
                });
            } else {
                this.notificationClientService.show("Error", "The file uploaded is not supported", NotificationType.Error);
                reject();
            }
        })
    }

    private checkCorrectFileTypes(files: File[]): boolean {
        if (files.length > 0) {
            
            const acceptedFileTypeList = Enumerable.from(this.acceptTypes.split(','))
                .select(x => x.trim());

            return Enumerable.from(files)
                .all(x => !x.type || acceptedFileTypeList.contains(x.type));
        }
        return true;
    }
}